/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import IntegratorCommercialConsultants from '../IntegratorCommercialConsultants';
import { IEditManyHandler } from '../../../contexts/sellersContext';
import useSellers from '../../../hooks/useSellers';
import selectOptionValuesAsString from '../../../utils/selectOptionValuesAsString';
import selectOptionLabelsAsString from '../../../utils/selectOptionLabelsAsString';
import IntegratorHttpService from '../../../services/http/integrator-http';
import { EditManySellersActions } from '../../../constants/editManySeller';
import { toast } from 'react-toastify';

interface EditManyIntegratorCommercialConsultantsProps {
    selectedCommercialConsultant: number | null;
    selectedCommercialConsultants: number[];
    onCommercialConsultantsChange: (value: number[]) => void;
    onRef?: (handler: IEditManyHandler) => void;
}

const IntegratorCommercialConsultantsEditMany: React.FC<EditManyIntegratorCommercialConsultantsProps> = ({
    selectedCommercialConsultants,
    selectedCommercialConsultant,
    onCommercialConsultantsChange,
    onRef,
}) => {
    const { 
        filterForm,
        actionToEditForm,
        selectedEditManyIds
    } = useSellers();
    const filterData = filterForm.watch();
    const {useFilters} = actionToEditForm.watch();
    const {
        filterTerm,
        filterAttachment,
        filterStatus,
        filterContract,
        filterComercialConsultants,
        filterCities,
        filterStates,
        filterStartDate,
        filterEndDate,
    } = filterData;

    const params = {
        term: filterTerm || '',
        ...(filterAttachment && {
            attachmentFilter: filterAttachment.value,
        }),
        ...(filterStatus?.length && {
            statusFilter: selectOptionValuesAsString(filterStatus),
        }),
        ...(filterContract?.length && {
            contractFilter: selectOptionValuesAsString(filterContract),
        }),
        ...(filterComercialConsultants?.length && {
            commercialConsultantsFilter: selectOptionValuesAsString(
                filterComercialConsultants,
            ),
        }),
        ...(filterCities?.length && {
            citiesFilter: selectOptionLabelsAsString(filterCities),
        }),
        ...(filterStates?.length && {
            statesFilter: selectOptionValuesAsString(filterStates),
        }),
        ...(filterStartDate && { startDateFilter: filterStartDate }),
        ...(filterEndDate && { endDateFilter: filterEndDate }),
    };

    React.useEffect(() => {
        const handler: IEditManyHandler = {
            execute: async () => {
                try{
                    const result = await IntegratorHttpService.updateMany({
                        filter: useFilters ? params : selectedEditManyIds,
                        newValue: selectedCommercialConsultant,
                        action: EditManySellersActions.Consultor
                    });
                    if (result.data){
                        toast.success('Alterações feita com sucesso');
                    }else{
                        toast.error('Houve um erro ao realizar a ação');
                    }
                } catch (err: any) {
                    toast.error(err.message);
                }
            },
        };
        onRef?.(handler);
    }, [onRef, selectedCommercialConsultants]);

    return (
        <IntegratorCommercialConsultants
            selectedCommercialConsultants={selectedCommercialConsultants}
            onCommercialConsultantsChange={onCommercialConsultantsChange}
        />
    );
};

export default IntegratorCommercialConsultantsEditMany;
